angular.module('impactx.userdialog').controller('DelegationDialogUserCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    'PartialDialogsService',
    DelegationDialogUserCtrl
]);

function DelegationDialogUserCtrl($scope, dataGen, $routeParams, BackService, ToastService, ToolbarService,
                                  PartialDialogsService) {
    var self = this;
    $scope.userId = $routeParams.id;
    dataGen.getData($scope, {id: $routeParams.id}, "/user/delegation/view").then(function () {
        defineButtons();
    });

    self.save = function ($event, showOthers) {
        var dataObj = {
            delegations: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/user/delegation/save").then(function () {
            ToastService.openStandardToast($scope.trns.saveSuccess);
            if(showOthers)
            {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, $scope.userId, 'userdelegation', undefined, true);
            }
            else
            {
                PartialDialogsService.addDialog(PartialDialogsService.TYPE.USER, $scope.userId, 'userdelegation');
                PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
            }
        });
    };

    self.saveBackToList = function ($event) {
        return self.save($event, false)
    };

    self.saveOtherDialogs = function ($event) {
        return self.save($event, true)
    };

    function valueFunction() {
        return $scope.data && $scope.data.userCard && $scope.data.userCard.maxNumberOfUsersReached
            && !$scope.data.userCard.canSaveWithMaxNumberOfUsersReached;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveBackToList,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: self.saveOtherDialogs,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}